import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstatusService {
  
  private endpoint: string | null;

  constructor(private httpClient: HttpClient) {
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/catalogos/Estatus';
  }

  getEstatus() {
    return this.httpClient.get( this.endpoint + '/GetEstatus');
  }

  insertEstatus(model: any) {
    return this.httpClient.post(this.endpoint + '/InsertEstatus', model);
  }

  updateEstatus(model: any) {
    return this.httpClient.post(this.endpoint + '/UpdateEstatus', model);
  }
}
